// import React from 'react';
import { Typography } from '@mui/material';

interface HtmlRendererProps {
  htmlContent: string;
}

function HtmlRenderer({ htmlContent }: HtmlRendererProps) {
  return (
    <Typography
      component="div"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}

export default HtmlRenderer;